import { c as _c } from "react/compiler-runtime";
import { useUser } from '@clerk/nextjs';
import { createContext, ReactNode, useContext } from 'react';
import { GlobalRole, GLOBAL_ROLES } from '@/config/global-roles';
interface UserRoleContextType {
  globalRole: GlobalRole;
  isInternalUser: boolean;
  isLoading: boolean;
}
const UserRoleContext = createContext<UserRoleContextType>({
  globalRole: null,
  isInternalUser: false,
  isLoading: true
});
export const UserRoleProvider = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const {
    isLoaded,
    user
  } = useUser();
  const role = isLoaded ? user?.publicMetadata?.global_role as GlobalRole | undefined ?? null : null;
  const isInternal = role === GLOBAL_ROLES.INTERNAL;
  const isLoading = !isLoaded;
  let t1;
  if ($[0] !== isInternal || $[1] !== isLoading || $[2] !== role) {
    t1 = {
      globalRole: role,
      isInternalUser: isInternal,
      isLoading
    };
    $[0] = isInternal;
    $[1] = isLoading;
    $[2] = role;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== t1) {
    t2 = <UserRoleContext.Provider value={t1}>{children}</UserRoleContext.Provider>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export const useCurrentUserRole = () => {
  return useContext(UserRoleContext);
};